import {Container} from "react-bootstrap";
import styles from "../../../assets/styles/ProjectPage.module.css"
import RecommendationSectorsPageView from "./RecommendationSectorsPageView";
import React from "react";
import {Administrator} from "../../../services/models/administrator";
import {SubUser} from "../../../services/models/sub_user";

interface Props {
    user: Administrator | SubUser | null
}

const RecommendationSectorsPage: React.FC<Props> = ({user}) => {
    return (
        <Container className={styles.projectPage}>
            <>
                <RecommendationSectorsPageView user={user}/>
            </>
        </Container>
    );
};

export default RecommendationSectorsPage;